function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import { classnames, tuple } from '@bydesign-ui/utils';
import { useDirection, usePrefixCls } from '@byte-design/config';
import RowContext from '../row/context/grid';
export function Col(props) {
  var span = props.span,
      order = props.order,
      offset = props.offset,
      push = props.push,
      pull = props.pull,
      xxs = props.xxs,
      xs = props.xs,
      sm = props.sm,
      md = props.md,
      lg = props.lg,
      xl = props.xl,
      xxl = props.xxl,
      className = props.className,
      children = props.children,
      style = props.style,
      others = _objectWithoutProperties(props, ["span", "order", "offset", "push", "pull", "xxs", "xs", "sm", "md", "lg", "xl", "xxl", "className", "children", "style"]);

  var rtl = useDirection() === 'rtl';
  var map = {
    span: span,
    order: order,
    offset: offset,
    push: push,
    pull: pull,
    xxs: xxs,
    xs: xs,
    sm: sm,
    md: md,
    lg: lg,
    xl: xl,
    xxl: xxl
  };

  var _useContext = useContext(RowContext),
      gutter = _useContext.gutter,
      breakpoint = _useContext.breakpoint;

  var cls = classnames(usePrefixCls('col', _objectSpread(_objectSpread({}, match(map, breakpoint)), {}, {
    rtl: rtl
  })), className);
  var realStyle = gutter > 0 ? _objectSpread({
    paddingLeft: gutter / 2,
    paddingRight: gutter / 2
  }, style) : style;
  return React.createElement("div", Object.assign({}, others, {
    style: realStyle,
    className: cls
  }), children);
}
var COL_PROP_TYPES = tuple('span', 'order', 'offset', 'push', 'pull');

function match(map, breakpoint) {
  var res = {};
  COL_PROP_TYPES.forEach(function (key) {
    var mv = map[breakpoint];
    var nv = map[key];

    if (key === 'span') {
      var value = _typeof(mv) === 'object' && mv[key] || typeof mv === 'string' && mv || typeof mv === 'number' && String(mv) || nv != null && nv || '0';
      res[value] = true;
      return;
    }

    res[key] = String(_typeof(mv) === 'object' && mv[key] || nv != null && nv || '0');
  });
  return res;
}